module.exports = __webpack_public_path__ + "res/13-img_play_bg.cc2edc86b856e24bb287127495b1dad7.webp";